import { render, staticRenderFns } from "./InstitutionOfCollection.vue?vue&type=template&id=e1f5c278&"
import script from "./InstitutionOfCollection.vue?vue&type=script&lang=ts&"
export * from "./InstitutionOfCollection.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionOfCollection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports